import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getShopifyTokens({ payload: { signal, onSuccess } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.shopify.get_tokens,
      signal
    });

    const preparedData = {
      dataTable: data.results,
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    onSuccess && onSuccess(data.results);
    yield put(actions.getShopifyTokensDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getShopifyTokensFailed,
      endpoint: api.shopify.get_tokens.url
    });
  }
}

export const getShopifyTokensSaga = takeEvery(types.GET_SHOPIFY_TOKENS_REQUEST, getShopifyTokens);